"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HumidityThresholds = exports.HumidityLevel = void 0;
var HumidityLevel;
(function (HumidityLevel) {
    HumidityLevel["Dry"] = "dry";
    HumidityLevel["Normal"] = "normal";
    HumidityLevel["SlightlyHumid"] = "slightly_humid";
    HumidityLevel["Humid"] = "humid";
    HumidityLevel["VeryHumid"] = "very_humid";
})(HumidityLevel = exports.HumidityLevel || (exports.HumidityLevel = {}));
exports.HumidityThresholds = {
    [HumidityLevel.Dry]: { low: 0, high: 30 },
    [HumidityLevel.Normal]: { low: 30, high: 50 },
    [HumidityLevel.SlightlyHumid]: { low: 50, high: 60 },
    [HumidityLevel.Humid]: { low: 60, high: 70 },
    [HumidityLevel.VeryHumid]: { low: 70, high: 100 },
};
